const tpl = (fields) => ({ page: 'skills', ...fields })

export const SKILL_TEMPLATES_PART04 = [
  tpl({
    id: 'demo-tpl-skl-nda-review',
    title: 'NDA review',
    category: 'Legal',
    apps: ['Gmail'],
    description: 'Checks an incoming NDA against your standard positions and drafts redlines for the gaps.',
    steps: ['Read the NDA from the email attachment', 'Compare each clause with your standard positions', 'Draft redlines and a short reply'],
    skill: {
      instructions: `**For the NDA attached to the email given:**

1. Identify whether it is mutual or one-way, the term, and the governing law.
2. Check definition of confidential information, exclusions, residuals, non-solicit, and remedies.
3. Mark each clause **OK**, **Negotiate**, or **Reject**, with a one-line reason.
4. Draft suggested redlines and a short reply email — save as a draft, never send.

Note that this is a first-pass review, not legal advice.`,
      examples: ['Review the NDA Globex sent this morning', 'Is the Initech NDA OK to sign?'],
    },
  }),
  tpl({
    id: 'demo-tpl-skl-action-items',
    title: 'Meeting notes to action items',
    category: 'Ops',
    apps: ['Notion', 'Slack'],
    description: 'Turns meeting notes into owned, dated action items and shares them with the attendees.',
    steps: ['Read the notes page', 'Extract decisions and action items with owners', 'Post the list to the team channel'],
    skill: {
      instructions: `**For the Notion meeting notes given:**

1. List every decision made, in one line each.
2. Extract action items as **Owner — task — due date**; ask if an owner is unclear.
3. Add the action items to the Notion Tasks database.
4. Post decisions and action items to the meeting's Slack channel.`,
      examples: ['Pull action items from today’s product sync', 'Turn the QBR notes into tasks'],
    },
  }),
]
